import React from 'react';
import { useLanguage } from '../components/language/LanguageContext';
import styles from './Footer.module.scss';

const Footer: React.FC = () => {
  const { t } = useLanguage();

  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        &copy; {new Date().getFullYear()} {t('landing.footer.rights')}
      </div>
    </footer>
  );
};

export default Footer;
